import ReactGA from "react-ga4";

// const API_URL =
//   process.env.NODE_ENV === "production"
//     ? "https://api.hackernoon.com/a/events"
//     : "http://localhost:5173/autumn/api/events";

export const logGA4Event = async (category = "", action = "", label, nonInteraction) => {
  if (category && action) {
    await ReactGA.event({
      category,
      action,
      ...(label && {label}),
      ...(nonInteraction && {nonInteraction}),
    });
  }
};

export const logEvent = async (category, action, label, nonInteraction) => {
  await logGA4Event(category, action);
  // fetch(`${API_URL}`, {
  //   method: "POST",
  //   headers: {"Content-Type": "application/json"},
  //   body: JSON.stringify({type: "site", category, action}),
  // }).catch(err => {});
};
